import { Box, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import API from "../../Api";
import { tokens } from "../../theme";

function Configs() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [config, setConfig] = useState(null);
  const [index, setIndex] = useState(null);
  const [open, setOpen] = React.useState(false);

  const showProgress = () => {
    setOpen(true);
  };
  const hideProgress = () => {
    setOpen(false);
  };

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        showProgress();
        const r = await API.get(`/config/RTS`);

        setConfig(r.data);
        const indexName = "DEALER_VEHICLE";
        const r1 = await API.get(`/index-config/${indexName}`);
        setIndex(r1.data);
      } catch (error) {
      } finally {
        hideProgress();
      }
    };

    fetchConfig();
  }, []);

  return (
    <Box m="10px">
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} onClick={hideProgress}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Typography variant="h3" align="center" color={colors.grey[200]} scope="row" sx={{ mb: 5 }}>
        Basic Configuration
      </Typography>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ fontSize: "1.0rem" }}>
                Name
              </TableCell>
              <TableCell align="left" sx={{ fontSize: "1.0rem" }}>
                Value
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {config && (
              <>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="left">PS Auth Url</TableCell>
                  <TableCell align="left">{config.PSAuthHost}</TableCell>
                </TableRow>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="left">PS Calc Url</TableCell>
                  <TableCell align="left">{config.PSCalcHost}</TableCell>
                </TableRow>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="left">TNF Url</TableCell>
                  <TableCell align="left">{config.TNFHost}</TableCell>
                </TableRow>

                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="left">Recipients</TableCell>
                  <TableCell align="left">
                    <ul>
                      {config.RecipientsEmail.map((m, i) => (
                        <li key={i}>{m}</li>
                      ))}
                    </ul>
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h3" align="center" color={colors.grey[200]} scope="row" sx={{ mt: 10, mb: 5 }}>
        Lunr Index Configuration
      </Typography>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ fontSize: "1.0rem" }}>
                Name
              </TableCell>
              <TableCell align="left" sx={{ fontSize: "1.0rem" }}>
                Value
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {index && (
              <>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="left">Index Name</TableCell>
                  <TableCell align="left">{index.IndexName}</TableCell>
                </TableRow>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="left">No of docs</TableCell>
                  <TableCell align="left">{index.NoOfDocuments}</TableCell>
                </TableRow>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="left">No of shards</TableCell>
                  <TableCell align="left">{index.NoOfShards}</TableCell>
                </TableRow>

                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="left">Docs by shards</TableCell>
                  <TableCell align="left">
                    <ul>
                      {Object.keys(index.Shards).map((m, i) => (
                        <li key={i}>
                          Shard#{m}= {index.Shards[m]} documents
                        </li>
                      ))}
                    </ul>
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default Configs;
